module.exports = __webpack_public_path__ + "static/recent-3-657e13df1fea5848e8569d9e6d8140f4.jpg";